import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
// import { MonitorService } from '@domain/infrastructure/api/monitor/monitor.service';
import { FailedAttemptOtpModel } from '@utils/classes/model/failed-attempt-otp-model';
import { IStep } from '../utils/interfaces/step.interface';

@Component({
  selector: 'ba-otp-step',
  templateUrl: './otp-step.component.html',
  styleUrls: ['./otp-step.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ]
})
export class OtpStepComponent implements IStep<void> {
  @Input() isClient: boolean = false;
  @Input() firstWindow: string = '';
  @Input() documentNumber!: string;
  @Output() stepDone = new EventEmitter<void>();
  @Output() exitFlowCreateAccount = new EventEmitter<void>();
  @Input() emailSelectedOtp: string = '';
  @Input() ruc: string = '';
  showViewOtpError: boolean = false;
  showViewLockOtp: boolean = false;
  numberOfAttemptsOtpCode: number = 3;

  constructor() { }

  onValidationCodeOtpStepDone(value: any) {
    this.firstWindow = 'code-validation';
    this.emailSelectedOtp = value;
  }

  onConfigurationStepDone(value: FailedAttemptOtpModel) {
    this.showViewOtpError = value.showViewOtpError;
    this.showViewLockOtp = value.showViewLockOtp;
    this.numberOfAttemptsOtpCode = value.numberOfAttemptsOtpCode;
    if (!this.showViewOtpError && !this.showViewLockOtp)
      this.stepDone.emit();
  }

  onShowValidationCodeOtp(value: FailedAttemptOtpModel) {
    this.showViewOtpError = value.showViewOtpError;
    this.showViewLockOtp = value.showViewLockOtp;
  }
}
